var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['category-item', { dark: _vm.theme == _vm.THEMES.DARK }, { active: _vm.active }],on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }